/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Equipment_Place_OutdoorsInputs */

const en_us2_onboarding_equipment_place_outdoors = /** @type {(inputs: Onboarding_Equipment_Place_OutdoorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outdoors`)
};

const pt_br2_onboarding_equipment_place_outdoors = /** @type {(inputs: Onboarding_Equipment_Place_OutdoorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao ar livre`)
};

const es_419_onboarding_equipment_place_outdoors = /** @type {(inputs: Onboarding_Equipment_Place_OutdoorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al aire libre`)
};

const pt_pt2_onboarding_equipment_place_outdoors = /** @type {(inputs: Onboarding_Equipment_Place_OutdoorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao ar livre`)
};

const fr_fr2_onboarding_equipment_place_outdoors = /** @type {(inputs: Onboarding_Equipment_Place_OutdoorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En plein air`)
};

const de_de2_onboarding_equipment_place_outdoors = /** @type {(inputs: Onboarding_Equipment_Place_OutdoorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draußen`)
};

const it_it2_onboarding_equipment_place_outdoors = /** @type {(inputs: Onboarding_Equipment_Place_OutdoorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All'aperto`)
};

/**
* | output |
* | --- |
* | "Outdoors" |
*
* @param {Onboarding_Equipment_Place_OutdoorsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_equipment_place_outdoors = /** @type {((inputs?: Onboarding_Equipment_Place_OutdoorsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Equipment_Place_OutdoorsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_equipment_place_outdoors(inputs)
	if (locale === "es-419") return es_419_onboarding_equipment_place_outdoors(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_equipment_place_outdoors(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_equipment_place_outdoors(inputs)
	if (locale === "de-DE") return de_de2_onboarding_equipment_place_outdoors(inputs)
	if (locale === "it-IT") return it_it2_onboarding_equipment_place_outdoors(inputs)
	return en_us2_onboarding_equipment_place_outdoors(inputs)
});
export { onboarding_equipment_place_outdoors as "onboarding.equipment_place.outdoors" }